export default {
  state: {
    userInfo: {
      show: false,
      verifiedNumber: [],
      forceUpdateProfile: false
      // firstName: '',
      // lastName: '',
      // birthMonth: '',
      // birthDay: '',
      // birthYear: '',
      // country: '',
      // mobile: '',
      // countryCode: 1,
      // email: '',
      // password: '',
      // rpassword: ''
    }
  },
  mutations: {
    setUserInfoData (state, data) {
      for (let field in data) {
        state.userInfo[field] = data[field]
      }
    },
    addVerifiedNumber (state, x) {
      if (state.userInfo.verifiedNumber.indexOf(x) === -1) {
        state.userInfo.verifiedNumber.push(x)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/global/user-info.js